<template>
    <div class="body-panel dataContent">
        <div class="body-panel-control separator"
             v-if="project != null && info.User && ((hasClaims(info.User.DynamicRole, claimEnums.bonusSpend) && project.Id !== 7) || hasClaims(info.User.DynamicRole, claimEnums.rewardsEdit) || info.User.MainRole === 'administrators' || info.ProjectsLength > 1)">
            <div class="body-panel-control-separator">
                <div class="control-block-left">
                    <div class="flex">
                        <p class="btn-back" v-if="$route.query.folderId != null">
                            <a class="router-link-active" href="" @click.prevent="$router.back()">Назад</a>
                        </p>
                        <project-select :user="info.User" @onChange="onProjectChange" v-if="info.User && (info.User.MainRole === 'administrators' || info.ProjectsLength > 1)"></project-select>
                    </div>
                </div>
                <div class="control-block-left" v-if="info.User && hasClaims(info.User.DynamicRole, claimEnums.bonusSpend)">
                    <div class="flex" style="align-items: flex-start; flex-direction: column; margin-top: 10px;">
                        <div class="flex" style="align-items: center;" v-if="project.RewardUnitTypeId === 1">
                            <p class="line-text">Всего баллов</p>
                            <p class="menu-item-info grey margin-left-5">{{ formatInt(info.User.PotentialBalance) }}</p>
                            <p class="line-text margin-left-5">из них доступно</p>
                            <p class="menu-item-info green margin-left-5">{{ formatInt(info.User.ActiveBalanceWithOrders) }}</p>

                        </div>
                        <div class="flex" v-if="project.RewardUnitTypeId === 2">
                            <p>Выдано купонов</p>
                            <p class="menu-item-info grey">{{ formatInt(info.User.PotentialBalance) }}</p>
                        </div>
                        <template v-if="info.User && info.User.MainRole !== 'administrators'">
                            <div class="error" v-if="(info.User.PassportVerificationState === 0)" style="padding:5px 15px 0px 40px">
                                Для выбора вознаграждения загрузите паспортные данные в <span style="border-bottom:1px solid #8394a0;cursor:pointer" @click="goToProfile()">профиле</span>
                            </div>
                            <div class="error" v-if="info.User.PassportVerificationState === 1" style="padding:5px 15px 0px 40px">
                                Мы проверяем загруженные документы. Скоро Вы сможете выбрать вознаграждение!
                            </div>
                            <div class="error" v-if="(info.User.PassportVerificationState === 3)" style="padding:5px 15px 0px 40px">
                                Мы не смогли принять загруженные документы, ознакомьтесь с причиной в <span style="border-bottom:1px solid #8394a0;cursor:pointer" @click="goToProfile()">профиле</span> и исправьте ошибки.
                            </div>
                        </template>
                    </div>
                </div>
                <div class="control-block-right">
                    <div class="flex btns">
                        <button type="button" class="btn"
                                @click.stop="onShowGroupsModal"
                                v-if="info.User && (hasClaims(info.User.DynamicRole, claimEnums.rewardsEdit) || info.User.MainRole === 'administrators')">
                            Управление группами
                        </button>
                        <button class="btn btn-news" @click="onAddFolder" v-if="info.User && (hasClaims(info.User.DynamicRole, claimEnums.rewardsEdit) || info.User.MainRole === 'administrators')">
                            Добавить папку
                        </button>
                        <button type="button" class="btn" @click="onAddReward()" v-if="info.User && (hasClaims(info.User.DynamicRole, claimEnums.rewardsEdit) || info.User.MainRole === 'administrators')">
                            Добавить
                        </button>
                        <button type="button" class="btn" @click="onExport()" v-if="info.User && info.User.MainRole === 'administrators'">
                            Экспорт
                        </button>

                        <router-link v-if="(project.RewardUnitTypeId === 1 || project.RewardUnitTypeId === 2) && hasClaims(info.User.DynamicRole, claimEnums.bonusSpend)" to="/bonus-history" class="header-menu-right-item">
                            История начислений баллов
                        </router-link>
                        <div style="clear: both;"></div>
                    </div>
                </div>
            </div>
            <div class="body-panel-control-separator flex">
                <div class="input-group">
                    <input type="text" class="input-text" v-model="search" placeholder="Поиск по названию и описанию" @input="onSearchChange($event)" />
                    <button type="button" class="btn btn-img input-group-addon" title="Очистить" @click="onSearchClear" v-if="search">
                        <i class="fa fa-close"></i>
                    </button>
                </div>
                <div class="switch margin-left-10"
                     v-if="info.User && (hasClaims(info.User.DynamicRole, claimEnums.rewardsEdit) || info.User.MainRole === 'administrators')">
                    <input type="checkbox" id="s5" checked="checked" v-model="active" @change="reload" />
                    <label class="slider-v3" for="s5"></label>
                </div>
            </div>
        </div>
        <div class="body-panel-content body-panel-content-page no-padding-right">
            <div class="body-panel-content-center flex btns margin-bottom-20" v-if="rewardTypes.length">
                <button type="button" :class="['btn', {'active': rewardTypeId === 0 }]" @click="onRewardTypeChange(0)">Все</button>
                <button type="button" v-for="type of rewardTypes" :class="['btn', {'active': rewardTypeId === type }]" @click="onRewardTypeChange(type)">
                    {{ getRewardTypeName(type) }}
                </button>
            </div>

            <div class="body-panel-content-center">

                <template v-for="item of rewards">
                    <h2 v-if="item.Group && item.Group.Name != null" class="group-header">{{ item.Group.Name }}</h2>
                    <div class="panel-block panel-block-new" @click="onItemClick(item)">
                        <div class="panel-block-img-base">
                            <div class="panel-block-img" v-if="item.Image">
                                <img :src="item.Image" alt="" :style="getImageStyleFormatted(item.ImageStyle)"/>
                            </div>
                        </div>
                        <div class="panel-block-info">
                            <p class="panel-block-header">{{ item.Name }}</p>
                            <p class="panel-body-desc" v-html="item.DescriptionFormatted"></p>
                            <p v-if="item.WebLink">
                                <button class="btn" :title="item.WebLink" :onclick="'window.open(\'' + item.WebLink + '\',\'_blank\')'">Перейти на сайт</button>
                            </p>
                        </div>
                        <div class="panel-body-actions flex" v-if="item.IsFolder || 
                             (
                                info.User && 
                                (info.User.PassportVerificationState === 2 || info.User.MainRole === 'administrators' || hasClaims(info.User.DynamicRole, claimEnums.rewardsEdit)) &&
                                (
                                 hasClaims(info.User.DynamicRole, claimEnums.bonusSpend) || 
                                 hasClaims(info.User.DynamicRole, claimEnums.rewardsEdit) || 
                                 info.User.MainRole === 'administrators'
                                )
                             )">
                            <template v-if="item.RewardType !== 4">
                                <div v-if="item.RewardType === 3 && (!info.User.PaymentSettings || info.User.PaymentSettings.VerificationState !== 2)">
                                    Необходимо заполнить раздел "Банковская карта" в Профиле
                                </div>
                                <template v-else>
                                    <button class="btn"
                                            @click.stop="getReward(item.Id, item.Prices[0].Id, item.RewardType)"
                                            v-if="item.ManualNominalPercent == null && item.Prices && item.Prices.length === 1">
                                        {{ getFormattedPriceDescription(item.Prices[0]) }}
                                    </button>

                                    <button class="btn"
                                            @click.stop="onShowManualNominalModal(item)"
                                            v-if="!item.Prices && item.ManualNominalPercent != null">
                                        Ввести вручную
                                    </button>

                                    <slide-down
                                            v-if="item.Prices != null && (item.Prices.length > 1 || item.ManualNominalPercent != null) && hasClaims(info.User.DynamicRole, claimEnums.bonusSpend)"
                                            :items="getPriceItemsForDropdown(item)"
                                            :selectText="'Выбрать номинал'"
                                            :dataField="'Id'"
                                            :textField="'Name'"
                                            @change="onPriceChange(...arguments, item)">
                                    </slide-down>
                                </template>
                            </template>

                            <template v-if="item.Prices != null && item.RewardType === 4">
                                <button class="btn"
                                        @click.stop="getReward(item.Id, item.Prices[0].Id, item.RewardType)"
                                        v-if="info.User && info.User.PassportVerificationState === 2
                                        && hasClaims(info.User.DynamicRole, claimEnums.bonusSpend)
                                        && item.Prices.length === 1
                                        && info.User.ActiveBalance >= item.Prices[0].Price">
                                    {{ getFormattedPriceDescription(item.Prices[0]) }}
                                </button>

                                <slide-down
                                    v-if="info.User
                                        && info.User.PassportVerificationState === 2
                                        && hasClaims(info.User.DynamicRole, claimEnums.bonusSpend)
                                        && item.Prices.length > 1"
                                    :items="getPriceItemsForDropdown(item)"
                                    :selectText="'Выбрать номинал'"
                                    :dataField="'Id'"
                                    :textField="'Name'"
                                    @change="onPriceChange(...arguments, item)">
                                </slide-down>
                            </template>

                            <button class="btn" @click.stop="goToFolder(item.Id)" v-if="item.IsFolder">
                                Подробнее
                            </button>

                            <button class="btn btn-img"
                                    @click.stop="editReward(item)"
                                    v-if="item.Id > 0 && info.User && (hasClaims(info.User.DynamicRole, claimEnums.rewardsEdit) || info.User.MainRole === 'administrators')">
                                <img src="../../img/pencil-edit-button.png" alt="" />
                            </button>
                            
                        </div>
                    </div>
                </template>

            </div>
        </div>

        <popup-window ref="ppGroups" :title="'Управление группами вознаграждений'" :width="800" :modal="true">
            <div>
                <Container @drop="onDrop" :lock-axis="'y'" @drag-start="onDragStart">
                    <Draggable v-for="(group, i) of groupsOrdered">
                        <div class="draggable-item" @click="onGroupSelect(group)">
                            <template v-if="group.Edited">
                                <div class="flex" style="">
                                    <input type="text" class="input-text"
                                           v-model="group.Name"/>
                                    <button class="btn btn-primary" @click.stop="onSaveGroup(group)">
                                        Ok
                                    </button>
                                    <button class="btn btn-default" @click.stop="onGroupEditCancel(group)">
                                        Отмена
                                    </button>
                                </div>
                            </template>
                            <template v-if="!group.Edited">
                                {{ group.Name }}
                                <div class="btns flex" style="float:right;margin-top:-6px">
                                    <button class="btn btn-default btn-img" @click.stop="onGroupEdit(group)">
                                        <img src="../../img/pencil-edit-button.png" alt="" />
                                    </button>
                                    <button class="btn btn-default btn-img" @click.stop="onRemoveGroup(group, i)">
                                        <img src="../../img/icon-del.png" alt="" />
                                    </button>
                                </div>
                            </template>
                        </div>
                    </Draggable>
                </Container>
            </div>
            <div class="flex btns">
                <button class="btn margin-top-10" @click.stop="onAddNewGroup">Добавить</button>
                <button class="btn margin-top-10" @click.stop="saveGroups" v-if="groupsChanged">Сохранить</button>
                <button class="btn margin-top-10" @click.stop="closeModal('ppGroups')">Отмена</button>
            </div>
        </popup-window>

        <popup-window ref="ppManualNominal" :title="'Укажите необходимую сумму'" :width="800" :modal="true">
            <div class="form-field">
                <input name="ManualSum" type="text"
                       v-validate="{required: true, positive: true}"
                       v-model="manual.sum"
                       data-vv-as="Сумма"
                       data-vv-scope="manual"
                       :class="['input-text', {'input-error': errors.has('ManualSum', 'manual')}]"
                />
                <span class="field-validation-valid">{{ errors.first('ManualSum') }}</span>
            </div>
            <div class="margin-bottom-20">
                {{ getCommissionText() }} {{ (totalManualSumWithComission ? totalManualSumWithComission.toFixed(2) : null) }}
            </div>

            <div class="flex btns">
                <button class="btn margin-top-10" @click.stop="onManualNominalAdd">Готово</button>
                <button class="btn margin-top-10" @click.stop="$refs['ppManualNominal'].close()">Отмена</button>
            </div>
        </popup-window>

        <popup-window ref="ppAddress" :title="'Укажите адрес доставки'" :width="800" :height="'90%'" :modal="true">
            <div class="form-field">
                <drop-down :items="address.list"
                           :dataField="'Id'"
                           :textField="'DisplayName'"
                           v-model="address.addressId"
                           @change="onAddressChange"></drop-down>
            </div>
            <div class="form-field">
                <label class="input-text-lbl">Получатель</label>
                <input name="addressFio" type="text"
                       v-validate="{required: true}"
                       v-model="address.data.Fio"
                       data-vv-as="Фио"
                       data-vv-scope="address"
                       :class="['input-text', {'input-error': errors.has('addressFio', 'address')}]"
                />
                <span class="field-validation-valid">{{ errors.first('addressFio') }}</span>
            </div>
            <div class="form-field">
                <label class="input-text-lbl">Телефон</label>
                <the-mask :mask="'# (###) ###-##-##'" name="addressPhoneNumber"
                          v-model="address.data.PhoneNumber"
                          v-validate="{ required: true, regex: /^\d{11}$/ }"
                          data-vv-scope="address"
                          data-vv-as="Телефон"
                          :class="['input-text', {'input-error': errors.has('addressPhoneNumber', 'address')}]" />
                <span class="field-validation-valid">{{ errors.first('addressPhoneNumber') }}</span>
            </div>
            <div class="form-field">
                <label class="input-text-lbl">Адрес</label>
                <input name="addressFullAddress" id="addressFullAddress" type="text"
                       v-validate="{required: true}"
                       v-model="address.data.FullAddress"
                       data-vv-as="Адрес"
                       data-vv-scope="address"
                       :class="['input-text', {'input-error': errors.has('addressFullAddress', 'address')}]"
                />
                <span class="field-validation-valid"></span>
            </div>

            <template v-slot:footer>
                <div class="popup-footer">
                    <div class="btns flex" data-toggle="buttons">
                        <button class="btn margin-top-10" @click.stop="onGetRewardWithAddress">Готово</button>
                        <button class="btn margin-top-10" @click.stop="$refs['ppAddress'].close()">Отмена</button>
                    </div>
                </div>
            </template>

        </popup-window>

        <vue-headful :title="getPageTitle()" />
    </div>
</template>

<script>
    import $ from 'jquery'
    import UI from '../helpers/ui-helpers'
    import BackendApi from '../backendApi'
    import projectMixin from '../helpers/project-mixin'
    import claimsCheckingMixin from '../helpers/claims-checking-mixin'
    import cart from '../cart'
    import { Container, Draggable } from 'vue-smooth-dnd'
    import {RewardTypes, CurrencyDetails} from '../enums'
    import _ from 'lodash'

    let backendApi = new BackendApi();
    let cacheKey = 'rewardsState';

    export default {
        name: "spend-bonuses",

        mixins: [projectMixin, claimsCheckingMixin],

        components: { Container, Draggable },

        data(){
            return{
                rewards: [],
                rewardTypes:[],
                rewardTypeId: 0,
                loading: false,
                canBeLoaded: true,
                page: 1,
                rowsPerPage: 25,
                active: true,
                projectId: null,
                search: null,
                groups: [],
                groupsOrigin: null,
                lastGroupId: null,
                scrollTop: null,
                firstLoad: true,
                project: null,

                selectedItem: null,

                manual: {
                    sum: null
                },

                address: {
                    list: [],
                    addressId: null,
                    data: {}
                },

                currencies: {
                  1: { symbol: '₽', name: 'рублей', commissionText: 'Сумма в рублях с учетом комиссии:' }, // Россия
                  2: { symbol: 'Br', name: 'белорусских рублей', commissionText: 'Сумма в белорусских рублях с учетом комиссии:' }, // Беларусь
                  3: { symbol: '₸', name: 'тенге', commissionText: 'Сумма в тенге с учетом комиссии:' } // Казахстан
                },
            }
        },

        computed: {
            groupsOrdered(){
                return _.orderBy(this.groups, 'GroupOrder');
            },

            groupsChanged(){
                return !_.some(this.groups, {Edited: true}) && JSON.stringify(this.groups) !== JSON.stringify(this.groupsOrigin);
            },

            totalManualSumWithComission(){
                let vm = this;

                let selectedSum = parseFloat(vm.manual.sum);
                if(!isNaN(selectedSum)){
                    if (vm.selectedItem.ManualNominalPercent > 0) {
                        let totalSumm = selectedSum * (100 - vm.selectedItem.ManualNominalPercent) / 100;
                        if (vm.selectedItem.RewardType === RewardTypes.ElectronicGiftCard && vm.selectedItem.OzonCertificate) {
                            totalSumm = Math.round(totalSumm);
                        }
                        return totalSumm;
                    }
                    else{
                        return selectedSum;
                    }
                }
                return null;
            }
        },

        watch: {
            '$route.query.folderId'(to, from) {
                this.reload();
            }
        },

        methods: {

            getCommissionText() {
              if (!this.project || !this.project.CountryId) {
                return 'Сумма с учетом комиссии:';
              }
              let currency = CurrencyDetails[this.project.CountryId];
              return currency.commissionText;
            },

            onShowGroupsModal(){
                let vm = this;
                vm.$refs['ppGroups'].show();

            },

            onDragStart () {
                let vm=this;
                vm.$nextTick(()=>{
                    let marginLeft = -($(document).width()-$('.popup-content').width())/2;
                    let marginTop = -($(document).height()-$('.popup-content').height())/2;
                    $('.smooth-dnd-ghost').css({'margin-left': marginLeft+'px', 'margin-top': marginTop+'px'});
                });

            },

            onRewardTypeChange(typeId){
                this.rewardTypeId = typeId;
                if(this.$route.query.folderId){
                    this.$router.push(this.$route.path);
                }
                else{
                    this.reload();
                }
            },

            onAddressChange(address){
                this.address.data = address;
            },

            loadAddresses(){
                let vm = this;
                this.callApiWrapper(backendApi.orderAddressList())
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки адресов');
                        } else {
                            let addressId = 0;
                            if(resp.data.length){
                                addressId = resp.data[resp.data.length - 1].Id;
                                for(let addr of resp.data){
                                    addr.DisplayName = addr.Fio + ' - ' + addr.FullAddress
                                }
                            }

                            vm.address.addressId = addressId;
                            vm.address.list = [
                                {Id: 0, DisplayName: 'Новый адрес', PhoneNumber: vm.info.User.PhoneNumber, Fio: vm.info.User.Fio, FullAddress: null},
                                ...resp.data
                            ];
                            vm.address.data = Object.assign({}, resp.data.find(x => x.Id === addressId));
                        }
                    });
            },

            onGetRewardWithAddress(){
                let vm = this;
                this.$validator.validateAll('address').then(result => {
                    if (!result) {
                        UI.toastr.error('Проверьте введённые данные');
                    } else {
                        let selectedAddress = vm.address.list.find(x => x.Id === vm.address.addressId);
                        let needToSave = selectedAddress.Id === 0;
                        if (!needToSave) {
                            // проверяем что адрес не был изменён
                            console.info('[selectedAddress.FullAddress, vm.address.data.FullAddress]', [selectedAddress.FullAddress, vm.address.data.FullAddress])
                            if (selectedAddress.Fio !== vm.address.data.Fio || selectedAddress.PhoneNumber !== vm.address.data.PhoneNumber ||
                                selectedAddress.FullAddress !== vm.address.data.FullAddress) {
                                needToSave = true;
                            }
                        }
                        else if (_.some(vm.address.list, x => x.Id > 0 && x.FullAddress === vm.address.data.FullAddress)){
                            UI.toastr.error('Указанный адрес уже имеется в списке');
                            return;
                        }

                        if (needToSave) {
                            this.callApiWrapper(backendApi.orderNewAddress(vm.address.data.Fio, vm.address.data.PhoneNumber, vm.address.data.FullAddress))
                                .then(function (resp) {
                                    if (resp.hasError && resp.status !== 401) {
                                        UI.toastr.error('Ошибка во время сохранения адреса');
                                    } else {
                                        if (vm.address.list.filter(x => x.Id === resp.data.Id).length == 0) {
                                            vm.address.list.push(resp.data);
                                        }

                                        cart.addItem(vm.selectedItem.Id, vm.selectedItem.Prices[0].Id, vm.selectedItem.RewardType, null, resp.data.Id);
                                        UI.toastr.success('Добавлено в корзину');
                                        vm.$emit('need-refresh-cart');
                                        vm.$refs['ppAddress'].close();
                                    }
                                });
                        }else{
                            cart.addItem(vm.selectedItem.Id, vm.selectedItem.Prices[0].Id, vm.selectedItem.RewardType, null, selectedAddress.Id);
                            UI.toastr.success('Добавлено в корзину');
                            this.$emit('need-refresh-cart');
                            vm.$refs['ppAddress'].close();
                        }
                    }
                });
            },

            onShowManualNominalModal(item){
                let vm = this;

                vm.selectedItem = item;
                vm.manual.sum =
                vm.$refs['ppManualNominal'].show();
            },

            onManualNominalAdd(){
                let vm = this;
                this.$validator.validateAll('manual').then(result => {
                    if (!result) {
                        UI.toastr.error('Проверьте введённые данные');
                    }
                    else {
                        let selectedSum = parseFloat(vm.manual.sum);
                        // Установка значений по умолчанию
                        let min = vm.selectedItem.ManualNominalMin !== null ? vm.selectedItem.ManualNominalMin : 100;
                        let max = vm.selectedItem.ManualNominalMax !== null ? vm.selectedItem.ManualNominalMax : 10000;
                        let step = vm.selectedItem.ManualNominalStep !== null ? vm.selectedItem.ManualNominalStep : 100;

                        // Проверка минимального значения
                        if (selectedSum < min) {
                            UI.toastr.error('Минимально возможная сумма - ' + min);
                            return;
                        }

                        // Проверка максимального значения
                        if (selectedSum > max) {
                            UI.toastr.error('Максимально возможная сумма - ' + max);
                            return;
                        }

                        // Проверка кратности шагу
                        let remainder = selectedSum % step;
                        if (remainder !== 0) {
                            UI.toastr.error(`Сумма должна быть кратной шагу - ${step}`);
                            return;
                        }
                        if(vm.info.User.ActiveBalance < selectedSum){
                            UI.toastr.error('Максимально возможная сумма - ' + vm.info.User.ActiveBalance);
                            return;
                        }
                        if (vm.selectedItem.RewardType === RewardTypes.ElectronicGiftCard && vm.selectedItem.OzonCertificate) {
                            let totalSumm = vm.totalManualSumWithComission;
                            if (vm.selectedItem.ManualNominalPercent > 99) {
                                UI.toastr.error('Минимально возможная сумма - 100000');
                                return;
                            } else if (totalSumm < 100) {
                                let summ = totalSumm * 100 / (100 - vm.selectedItem.ManualNominalPercent) + 1;
                                UI.toastr.error('Минимально возможная сумма - ' + Math.round(summ));
                                return;
                            }
                        }
                        cart.addItem(vm.selectedItem.Id, 0, vm.selectedItem.RewardType, selectedSum);
                        UI.toastr.success('Добавлено в корзину');
                        this.$emit('need-refresh-cart');
                        vm.$refs['ppManualNominal'].close();
                    }
                });
            },

            getRewardTypeName(type) {
                switch (type) {
                    case RewardTypes.ElectronicGiftCard:
                        return 'Электронный сертификат';
                    case RewardTypes.PrepaidBankCard:
                        return 'Предоплаченная карта';
                    case RewardTypes.PhysicalBankCard:
                        return 'Выплата на карту';
                    case RewardTypes.PhysicalPrize:
                        return 'Физические призы';
                    default:
                        return '';
                }
            },

            getImageStyleFormatted(imageStyle){
                if(!imageStyle){
                    return null;
                }

                let settings = {
                    left: imageStyle.left + '%',
                    top: imageStyle.top + '%',
                    transform: 'translateY(' + imageStyle.translateY + '%) translateX(' +
                    imageStyle.translateX + '%)'
                };
                if(imageStyle.resizeType === 1 && parseInt(imageStyle.size)){
                    settings.height = imageStyle.size + '%';
                }
                if(imageStyle.resizeType === 2 && parseInt(imageStyle.size)){
                    settings.width = imageStyle.size + '%';
                }

                return settings;
            },

            getFormattedPriceDescription(priceItem) {
              if (!this.project || !this.project.CountryId) {
                return `${this.formatInt(priceItem.Price)} баллов`;
              }
              let currency = CurrencyDetails[this.project.CountryId];
              let priceDescription = `${this.formatInt(priceItem.Price)} баллов`;

              if (priceItem.Nominal) {
                priceDescription = `${this.formatInt(priceItem.Nominal)} ${currency.symbol} за ${priceDescription}`;
              }

              return priceDescription;
            },

            getPriceItemsForDropdown(item){
                let vm = this;

                let mapped = item.Prices.map((x => {
                    return { Id: x.Id, RewardId: x.RewardId, Name: vm.getFormattedPriceDescription(x) }
                }));
                //if ((item.RewardType === RewardTypes.PhysicalBankCard || item.RewardType === RewardTypes.ElectronicGiftCard && item.OzonCertificate)
                if(item.RewardType !== RewardTypes.PhysicalPrize && item.ManualNominalPercent != null) {
                    mapped.push({
                        Id: -1, RewardId: item.RewardId, Name: 'Внести вручную'
                    });
                }
                return [...mapped];
            },

            onPriceChange(item, rewardItem){
                let prices= rewardItem.Prices,
                    rewardType = rewardItem.RewardType;

                if (item.Id > 0) {
                    let price;
                    for (let itemPrice of prices) {
                        if (itemPrice.Id === item.Id) {
                            price = itemPrice.Price;
                            break;
                        }
                    }
                    if (price > this.info.User.onlyActiveBalance) {
                        UI.toastr.error('Недостаточно средств на балансе');
                    } else {
                        cart.addItem(item.RewardId, item.Id, rewardType);

                        UI.toastr.success('Добавлено в корзину');

                        this.$emit('need-refresh-cart');
                    }
                //} else if (item.Id === -1 && (rewardType === RewardTypes.PhysicalBankCard || rewardType === RewardTypes.ElectronicGiftCard && rewardItem.OzonCertificate)){
                } else if(item.Id === -1 && rewardType !== RewardTypes.PhysicalPrize) {
                    this.onShowManualNominalModal(rewardItem);
                }
            },

            getReward(rewardId, priceId, rewardType){
                let vm = this;
                if(rewardType === RewardTypes.PhysicalPrize){

                    this.selectedItem = this.rewards.find(x => x.Id === rewardId);
                    this.$refs['ppAddress'].show();
                    this.loadAddresses();
                    this.$nextTick(() => {

                        let suggestView = new ymaps.SuggestView('addressFullAddress', {results: 8})
                        suggestView.state.events.add('change', function () {
                            let activeIndex = suggestView.state.get('activeIndex');
                            if (typeof activeIndex == 'number') {
                                let activeItem = suggestView.state.get('items')[activeIndex];
                                if (activeItem) {
                                    vm.address.data.FullAddress = activeItem.value;
                                }
                            }
                        });

                    });
                }else{
                    cart.addItem(rewardId, priceId, rewardType);
                    UI.toastr.success('Добавлено в корзину');
                    this.$emit('need-refresh-cart');
                }
            },

            // onInputAddress: _.debounce(function(){
            //     console.info('onInputAddress, this.address.data.FullAddress:', this.address.data.FullAddress)
            //     ymaps.suggest(this.address.data.FullAddress).then(function (items) {
            //         // items - массив поисковых подсказок.
            //         console.info('items:', items);
            //     });
            // }, 300),

            loadNext(){
                let vm = this;

                UI.blockUI('.dataContent', 'Загрузка...');
                let skip = (vm.page - 1) * vm.rowsPerPage;
                let take = vm.rowsPerPage;
                if(vm.firstLoad && vm.page > 1) {
                    skip = 0;
                    take = vm.page * vm.rowsPerPage;
                }

                vm.loading = true;
                let onlyActive = true;
                let folderId = vm.$route.query.folderId;
                if(vm.info.User.MainRole === 'administrators'){
                    onlyActive = false;
                }
                this.callApiWrapper(backendApi.rewardsAggregateList(skip, take, vm.projectId, vm.search, onlyActive, folderId, vm.rewardTypeId, vm.active))
                    .then(function (resp) {
                        if(resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки вознаграждений');
                        }
                        else {
                            if (resp.data.list && resp.data.list.length) {
                                for (let item of resp.data.list) {
                                    if (item.ImageStyle) {
                                        item.ImageStyle = JSON.parse(item.ImageStyle);
                                    }
                                    if (item.Description) {
                                        item.DescriptionFormatted = item.Description.replace(/\n/g, '<br>');
                                    }
                                    if (!item.IsFolder) {
                                        if (item.Group) {
                                            if (item.Group.Id !== vm.lastGroupId) {
                                                vm.lastGroupId = item.Group.Id;
                                                item.Group.Name = vm.groups.find(x => x.Id === item.Group.Id).Name;
                                            } else {
                                                item.Group.Name = null;
                                            }
                                        } else {
                                            if (vm.lastGroupId == null && vm.groups.length) {
                                                vm.lastGroupId = 0;
                                                item.Group = {Id: 0, Name: 'Группа не выбрана'};
                                            }
                                        }
                                    }
                                }

                                vm.rewards.push(...resp.data.list);

                                if (vm.firstLoad) {
                                    vm.firstLoad = false;
                                    if (vm.scrollTop) {
                                        $('.body-panel-content').animate({scrollTop: vm.scrollTop}, 500);
                                    }
                                }
                            } else {
                                vm.canBeLoaded = false;
                            }
                            vm.rewardTypes = resp.data.rewardTypes;
                        }
                        UI.unblockUI('.dataContent');
                        vm.loading = false;
                    })
            },

            goToFolder(id) {
                this.saveFilterState();
                this.$router.push('/spend-bonuses/?folderId=' + id);
            },

            onItemClick(item){
                if(item.IsFolder){
                    this.saveFilterState();
                    this.$router.push('/spend-bonuses/?folderId=' + item.Id);
                }
            },

            editReward(item){
                this.saveFilterState();
                if(item.IsFolder){
                    this.$router.push('/rewards/folder/edit/' + item.Id);
                }else{
                    this.$router.push('/rewards/edit/' + item.Id);
                }
            },

            goToProfile(id) {
                this.$router.push('/profile');
            },

            onAddReward(){
                this.saveFilterState();
                this.$router.push('/rewards/edit/0');
            },

            onAddFolder(){
                this.saveFilterState();
                let folderId = this.$route.query.folderId;
                this.$router.push('/rewards/folder/edit/0'+ (folderId ? '?folderId=' + folderId : ''));
            },

            reload(){
                let vm = this;

                vm.page = 1;
                vm.rewards = [];
                vm.groups = [];
                vm.groupsOrigin = null;
                vm.canBeLoaded = true;
                vm.lastGroupId = null;
                vm.scrollTop = null;
                vm.firstLoad = true;

                vm.recoverFilterState();
                vm.loadGroups().then(function () {
                    if(!vm.loading && vm.canBeLoaded){
                        vm.loadNext();
                    }
                });
            },

            onSearchChange: _.debounce(function () {
                this.reload();
            }, 500),

            onSearchClear(){
                this.search=null;
                this.reload();
            },


            onProjectChange(item){
                if(this.$route.query.folderId){
                    this.$router.replace({query: {}});
                }
                this.projectId = item.Id;
                this.clearFilterState();

                this.reload();
                this.$emit('user-updated');
            },

            loadGroups(){
                let vm = this;

                return this.callApiWrapper(backendApi.rewardGroupList(vm.projectId))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки групп');
                        }
                        else {
                            if (resp.data) {
                                resp.data.forEach((r) => {
                                    r.Edited = false;
                                    r.Selected = false;
                                    r.OriginName = r.Name;
                                });

                                vm.groups = resp.data;
                                vm.groupsOrigin = JSON.parse(JSON.stringify(resp.data));
                            }
                        }
                    })
            },

            loadProject(){
                let vm = this;

                return this.callApiWrapper(backendApi.projectLoad(vm.projectId)).then(function (resp) {
                    if (resp.data) {
                        vm.project = resp.data;
                    }
                });
            },

            onAddNewGroup(){
                let vm = this;
                let maxOrder = 1;
                this.groups.forEach((r) => {
                    if(r.GroupOrder > maxOrder){
                        maxOrder = r.GroupOrder;
                    }
                    r.Edited = false;
                });

                this.groups.push({Id: 0,
                    Name: 'Новая группа',
                    OriginName: 'Новая группа',
                    ProjectId: vm.projectId,
                    GroupOrder: ++maxOrder,
                    Edited: true,
                    Selected: true
                });
            },

            onDrop(dropResult){
                let vm = this;

                if(dropResult.removedIndex === dropResult.addedIndex){
                    return;
                }

                let rolesTemp = _.orderBy(vm.groups, 'GroupOrder');
                let itemToAdd;
                if (dropResult.removedIndex != null) {
                    itemToAdd = rolesTemp.splice(dropResult.removedIndex, 1)[0];
                }
                if (dropResult.addedIndex !== null) {
                    rolesTemp.splice(dropResult.addedIndex, 0, itemToAdd)
                }

                let order = 1;
                rolesTemp.forEach((role) => {
                    role.GroupOrder = order++;
                });

                vm.groups = rolesTemp;

                //this.saveRoles(this.groups);
            },

            onGroupEdit(role){
                // if(_.some(this.groups, {Edited: true})){
                //     return;
                // }

                this.groups.forEach((r) => {
                    r.Edited = false;
                });
                role.Edited = true;
            },

            onGroupSelect(role){
                this.groups.forEach((r) => {
                    r.Selected = false;
                });
                role.Selected = true;
            },

            onRemoveGroup(role, index){
                let vm = this;
                let indexRemove;
                for(let i = 0; i< vm.groups.length; i++){
                    if(vm.groups[i].GroupOrder === role.GroupOrder){
                        indexRemove = i;
                        break;
                    }
                }
                vm.groups.splice(indexRemove, 1);
            },

            onSaveGroup(group) {
                if(group.Name){
                    group.Edited = false;
                    group.OriginName = group.Name;
                }
            },

            saveGroups() {
                let vm = this;

                UI.blockUI('.portlet', 'Сохранение...');
                let saveObj = [];
                for(let g of vm.groups){
                    saveObj.push(Object.assign({}, g, {
                        //ProjectId: vm.$route.params.projectId
                    }))
                }

                backendApi.rewardsGroupsSave(vm.projectId, saveObj).then(function (response) {
                    UI.unblockUI('.portlet');
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при сохранении групп');
                    } else {
                        UI.toastr.success('Успешно сохранено');
                        vm.reload();
                        vm.closeModal('ppGroups');
                    }
                });
            },

            onGroupEditCancel(group){
                group.Edited = false;
                group.Name = group.OriginName;
            },

            saveFilterState() {
                let stateObj = {
                    projectId: this.projectId,
                    search: this.search,
                    folderId: this.$route.query.folderId,
                    page: this.page,
                    scrollTop: this.scrollTop,
                    active: this.active
                };
                sessionStorage.setItem(cacheKey, JSON.stringify(stateObj));
            },

            recoverFilterState() {
                let stateObj = JSON.parse(sessionStorage.getItem(cacheKey));
                if (stateObj) {
                    if(((stateObj.folderId || 0) === (this.$route.query.folderId || 0)) && (stateObj.projectId == this.projectId)){
                        if(stateObj.search) {
                            this.search = stateObj.search;
                        }
                        if(stateObj.page) {
                            this.page = stateObj.page;
                        }
                        if(stateObj.scrollTop) {
                            this.scrollTop = stateObj.scrollTop;
                        }
                        if(stateObj.active != undefined) {
                            this.active = stateObj.active;
                        }
                        this.clearFilterState();
                    }
                    else{
                        sessionStorage.removeItem(cacheKey);
                    }
                }
            },

            clearFilterState(){
                sessionStorage.removeItem(cacheKey);
            },

            onExport() {
                let vm = this;
                let folderId = vm.$route.query.folderId;

                UI.blockUI('#app');
                vm.callApiWrapper(backendApi.rewardsExport(folderId, vm.search, vm.active, vm.rewardTypeId))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время экспорта вознаграждений');
                        }
                        else {
                            UI.downloadFileByBytes(resp.data, 'Вознаграждения.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                        }

                        UI.unblockUI('#app');
                    });
            }
        },

        mounted(){
            let vm = this;

            vm.recoverFilterState();

            Promise.all([vm.loadGroups(), vm.loadProject()]).then(function () {
                vm.loadNext();
                console.info('info.User.PaymentSettings', vm.info.User.PaymentSettings);
            });

            vm.$nextTick(() => {

                $('.body-panel-content').on('scroll', function () {
                    let elem = $(this);
                    let scrollTop = elem.scrollTop();
                    vm.scrollTop = scrollTop;
                    if(!vm.loading && vm.canBeLoaded) {
                        if (elem[0].scrollHeight - scrollTop - 200 <= elem.outerHeight()) {
                            vm.page++;
                            vm.loadNext();
                        }
                    }
                });
            });
        },

        destroyed(){
            $('.body-panel-content').off('scroll');
        }
    }
</script>


// WEBPACK FOOTER //
// Content/src/views/SpendBonuses.vue